export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATION_FLOWS: 'automation_flows_engine',
  BILLING_SCREEN: 'billing_screen',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  COMPANIES: 'companies',
  FRANCHISES: 'franchises',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  CUSTOM_REPORTS: 'custom_reports',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  SURVEYS: 'surveys',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  CUSTOM_ROLES: 'custom_roles',
  WAVOIP: 'wavoip',
  MASS_OUTBOUND: 'mass_outbound',
  SCHEDULED_MESSAGES: 'scheduled_messages',
  KANBAN_VIEW: 'kanban_view',
  META_LEADGEN: 'meta_leadgen',
  FLIP_LEADS: 'flip_leads',
  FLIP_LEADS_ENRIQUECIMENTO: 'flip_leads_enriquecimento',
  INTERNAL_CHAT: 'internal_chat',
};
